import * as v from "valibot";
import { rpcContract } from "../rpc";

/**
 * Get creator's subscription tier information
 * Shows pricing and details for a creator's Premium Membership
 * Used to display subscription info before checkout
 */
export const getCreatorSubscriptionInfoRpcContract = rpcContract({
  name: "get-creator-subscription-info",
  paramsSchema: v.object({
    influencerId: v.string(),
  }),
  resultSchema: v.object({
    tier: v.nullable(
      v.object({
        id: v.string(),
        name: v.string(),
        description: v.optional(v.string()),
        monthlyPriceCents: v.number(),
      }),
    ),
  }),
});

export type GetCreatorSubscriptionInfoParams = v.InferOutput<
  (typeof getCreatorSubscriptionInfoRpcContract)["paramsSchema"]
>;
export type GetCreatorSubscriptionInfoResult = v.InferOutput<
  (typeof getCreatorSubscriptionInfoRpcContract)["resultSchema"]
>;
